import React from "react";
import { linkCardItems } from "./helper";
import { Link } from "react-router-dom";
import "./style.scss";
import { useReferModal } from "context/ReferModalProvider";
import { useFeedBack } from "context/FeedBackModelContext";

function LinkCard({ data = linkCardItems, setModal }) {
  // const { setReferOpen } = useReferModal();
  const { setFeedBackOpen } = useFeedBack();

  return (
    <div className="link-card">
      {data.map((item) => {
        // if (item.label === "Refer a friend") {
        //   return (
        //     <div
        //       key={item.key}
        //       className="item-container"
        //       style={{ cursor: "pointer" }}
        //       onClick={() => setReferOpen(true)}
        //     >
        //       <span className="icon">{item?.icon && <item.icon />}</span>
        //       <p className="font-title-xs link-text">{item.label}</p>
        //     </div>
        //   );
        // }
        if (item.label === "Feedback") {
          return (
            <div
              key={item.key}
              className="item-container"
              style={{ cursor: "pointer" }}
              onClick={() => setFeedBackOpen(true)}
            >
              <span className="icon">{item?.icon && <item.icon />}</span>
              <p className="font-title-xs link-text">{item.label}</p>
            </div>
          );
        }

        if (item.label === "Log out") {
          return (
            <div
              key={item.key}
              className="item-container"
              style={{ cursor: "pointer" }}
              onClick={() => setModal(true)}
            >
              <span className="icon">{item?.icon && <item.icon />}</span>
              <p className="font-title-xs link-text">{item.label}</p>
            </div>
          );
        }

        return (
          <Link
            to={item.href}
            key={item.key}
            className="item-container"
            state={item.state}
          >
            <span className="icon">{item?.icon && <item.icon />}</span>
            <p className="font-title-xs link-text">{item.label}</p>
          </Link>
        );
      })}
    </div>
  );
}

export default LinkCard;
